import {
  GoalAssignment,
  GoalsScreen,
  GoalTemplate,
  PersonalGoalInitResponse,
} from "@/apps/goals/types";

export interface CurrentGoalData {
  template: GoalTemplate;
  assignment: GoalAssignment;
  rewardAmount: number;
  ridesRequired: number;
  completedRides: number;
  expiresAt: number;
}

export const getCurrentGoalTemplate = (
  initData: PersonalGoalInitResponse | null
) =>
  initData?.program.templates.find(
    (template) =>
      template.template_id === initData.current_assignment?.template_id
  ) ?? null;

export const getCurrentGoalData = (
  initData: PersonalGoalInitResponse | null
): CurrentGoalData => {
  const template = getCurrentGoalTemplate(initData);
  const assignment = initData?.current_assignment ?? null;

  if (!initData || !assignment || !template) {
    throw new Error("Current goal data is missing");
  }

  return {
    template,
    assignment,
    rewardAmount: initData.program.goal_price,
    ridesRequired: template.rides_required,
    completedRides: assignment.rides,
    expiresAt: new Date(assignment.ends_at).getTime(),
  };
};

export const getGoalsScreenFromInitData = (
  initData: PersonalGoalInitResponse
): GoalsScreen => {
  if (initData.current_region_group_id == null) {
    return "regionSelector";
  }

  if (!initData.current_assignment) {
    return "wheel";
  }

  const currentGoal = getCurrentGoalData(initData);

  if (
    currentGoal.assignment.completed_at ||
    currentGoal.completedRides >= currentGoal.ridesRequired
  ) {
    return "goalCompleted";
  }

  if (currentGoal.expiresAt && currentGoal.expiresAt <= Date.now()) {
    return "goalFailed";
  }

  return "activeGoal";
};
